import compose from 'recompose/compose';
import lifecycle from 'recompose/lifecycle';
import mapProps from 'recompose/mapProps';
import { connect } from 'react-redux';
import withQueryParams from '../../hocs/withQueryParams';
import withProductCustomisation from '../../hocs/withProductCustomisation';
import {
  getDefaultCustomisations,
  replaceCanvasText,
  getDefaultInscription,
  mergeLocalisedDrawers,
  getCompletedDrawersMap,
  shouldInscriptionUpdate,
  shouldFetchPrismicProduct,
  getNextTJHCustomisation,
} from './helpers';
import withCanvasPrimary from './withCanvasPrimary';
import { withModel } from '../../data-providers/model';
import { findVariantPrice } from 'src/common/utils/product';
import { replaceTextWithValues } from 'src/common/utils/text-replace';
import { getActiveCanvasDrawer } from '../CanvasDrawers/duck';
import { addFlashMessageNotice } from '../FlashMessages/duck';
import { fetchPrismicProduct } from 'src/client/js/store/thunks/prismic/product';
import {
  getPrismicProduct,
  getPrismicProductByLocale,
  getPrismicProductDrawer,
} from 'src/client/js/store/selectors/prismic/product';
import Canvas from './Canvas';
import omit from 'lodash/omit';

const enhance = compose(
  withProductCustomisation,
  withQueryParams,
  withModel,
  withCanvasPrimary,
  connect(
    (state, props) => ({
      isDrawerOpen: !!getActiveCanvasDrawer(state),
      inscriptionDrawer: getPrismicProductDrawer(
        state,
        props.primary.productId,
        props.productCustomisation.locale,
        'inscription',
      ),
      prismicProductLangs: getPrismicProduct(
        state,
        props.primary.productId
      ),
      prismicProduct: getPrismicProductByLocale(
        state,
        props.primary.productId,
        props.productCustomisation.locale,
      ),
    }),
    dispatch => ({
      flashMessage: message => message && dispatch(addFlashMessageNotice(message)),
    }),
  ),
  connect(
    null,
    (dispatch, props) => ({
      fetchPrismicProduct: (sku, locale) =>
        dispatch(fetchPrismicProduct(sku, locale, props)),
    })
  ),
  mapProps(props => {
    const isEditing = !!props.match.params.itemId;
    let cta = isEditing ? props.primary.editingCta : props.primary.cta;
    let completedCta = isEditing
      ? props.primary.completedEditingCta
      : props.primary.completedCta;
    const localisedDrawers = mergeLocalisedDrawers(props);
    const propsWithDrawers = {
      ...props,
      drawers:
        localisedDrawers.length > 0
          ? { ...props.primary.drawers, other: localisedDrawers }
          : props.primary.drawers,
    };
    const completedDrawersMap = getCompletedDrawersMap(propsWithDrawers);
    return {
      ...propsWithDrawers,
      completedDrawersMap,
      isDrawersVisible: props.primary.body.length > 0 || !!cta,
      title: replaceCanvasText(props.primary.title, props),
      editingBanner: props.primary.editingBanner,
      continueCtaText: cta,
      completedCtaText: replaceTextWithValues(completedCta || cta, {
        price: findVariantPrice(
          props.products,
          props.primary.productId,
          omit(props.productCustomisation, ['box', 'cover', 'components']),
        ),
      }),
    };
  }),
  lifecycle({
    componentDidMount() {
      const props = this.props;
      const customisation = {
        ...getDefaultCustomisations(props),
        ...props.queryParams,
      };
      props.updateProductCustomisation(customisation);

      if (props.match.params.itemId) {
        const canvasFlashMessage = replaceCanvasText(props.editingBanner, {
          ...props,
          productCustomisation: customisation,
        });
        props.flashMessage(canvasFlashMessage);
      }

      this.props.fetchPrismicProduct(
        props.primary.productId,
        customisation.locale,
      );
    },

    componentDidUpdate(prevProps) {
      const props = this.props;

      if (shouldInscriptionUpdate(prevProps, props)) {
        const inscription = getDefaultInscription(props, props.inscriptionDrawer);
        prevProps.updateProductCustomisation({ inscription });
      }

      if (shouldFetchPrismicProduct(prevProps, props)) {
        prevProps.fetchPrismicProduct(
          props.primary.productId,
          props.productCustomisation.locale,
        );
      }

      const nextTJHCustomisation = getNextTJHCustomisation(
        prevProps,
        props,
      );
      if (nextTJHCustomisation) {
        prevProps.updateProductCustomisation(nextTJHCustomisation);
      }
    },
  }),
);

export default enhance(Canvas);



// WEBPACK FOOTER //
// ./src/client/js/view/components/Canvas/index.js